import React, { memo } from 'react';
import { View, ActivityIndicator, StyleSheet } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';

export const LoadingContainer = memo(
  ({
    children,
    isInitial = false,
    isBusy = isInitial,
    hasOverlay = true,
    style,
    ...rest
  }) => {
    const { styles, colors } = useStyle();
    return (
      <View style={[styles.container, style]} {...rest}>
        {isInitial && isBusy ? null : children}
        {isBusy && (
          <View
            style={[
              styles.indicatorContainer,
              hasOverlay && styles.indicatorContainerBackground,
            ]}
          >
            <ActivityIndicator size="large" color={colors.red1} />
          </View>
        )}
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow }) => ({
  container: {
    flex: 1,
  },
  indicatorContainer: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
  },
  indicatorContainerBackground: {
    backgroundColor: colors.white3,
  },
}));
